<template>
  <div class="input-group justify-content-center col-md-12 margin-bottom-10px">
    <vue-bootstrap-typeahead
      v-model="query"
      :data="vocabularyKeyword"
      :minMatchingChars="1"
      class="col-md-4 no-padding-right"
    />
    <div class="input-group-append">
      <button id="button-addon5" type="submit" class="btn btn-primary">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  name: "CountrySearch",
  components: {
    VueBootstrapTypeahead
  },
  data() {
    return {
      query: "",
      vocabularyKeyword: []
    };
  },
  mounted: function() {
    this.vocabularyKeyword = this.$store.getters.getAllVocabularyKeyword;
  },
  watch: {
    query: function(_query) {
      if (this.$store.getters.isVocabularyExist(_query)) {
        $("#select_strategy").val(0);
        $("#select_reform").val(0);
        $(".selectpicker").selectpicker("refresh");
        this.$router.push({ name: "word", params: { id: _query } });
      }
    }
  }
};
</script>
<style>
.no-padding-right {
  padding-right: 0px !important;
}
.margin-bottom-10px {
  margin-bottom: 20px;
}
</style>
